var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "message-dots-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M6.25 10.6538H6.25833M10 10.6538H10.0083M13.75 10.6538H13.7583M10 18.1538C14.1421 18.1538 17.5 14.796 17.5 10.6538C17.5 6.5117 14.1421 3.15384 10 3.15384C5.85786 3.15384 2.5 6.5117 2.5 10.6538C2.5 11.6515 2.69478 12.6036 3.04839 13.4743C3.11606 13.6409 3.1499 13.7242 3.165 13.7916C3.17976 13.8575 3.18516 13.9062 3.18517 13.9737C3.18518 14.0428 3.17265 14.1179 3.14759 14.2683L2.65344 17.2332C2.60169 17.5437 2.57582 17.6989 2.62397 17.8112C2.66611 17.9094 2.7444 17.9877 2.84265 18.0299C2.95491 18.078 3.11015 18.0521 3.42063 18.0004L6.38554 17.5062C6.53591 17.4812 6.61109 17.4687 6.68011 17.4687C6.74763 17.4687 6.79638 17.4741 6.86227 17.4888C6.92962 17.5039 7.01294 17.5378 7.17958 17.6055C8.05025 17.9591 9.00238 18.1538 10 18.1538ZM6.66667 10.6538C6.66667 10.884 6.48012 11.0705 6.25 11.0705C6.01988 11.0705 5.83333 10.884 5.83333 10.6538C5.83333 10.4237 6.01988 10.2372 6.25 10.2372C6.48012 10.2372 6.66667 10.4237 6.66667 10.6538ZM10.4167 10.6538C10.4167 10.884 10.2301 11.0705 10 11.0705C9.76988 11.0705 9.58333 10.884 9.58333 10.6538C9.58333 10.4237 9.76988 10.2372 10 10.2372C10.2301 10.2372 10.4167 10.4237 10.4167 10.6538ZM14.1667 10.6538C14.1667 10.884 13.9801 11.0705 13.75 11.0705C13.5199 11.0705 13.3333 10.884 13.3333 10.6538C13.3333 10.4237 13.5199 10.2372 13.75 10.2372C13.9801 10.2372 14.1667 10.4237 14.1667 10.6538Z",
    stroke: "#676A73",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageDefault);
export default __webpack_public_path__ + "static/media/messageDefault.d21dd264006d4092db603755af4614f3.svg";
export { ForwardRef as ReactComponent };